<template>
  <div class="package-container">
    <navbar />
    <Package v-bind:id="id" v-bind:name="name" v-bind:price="price" />
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from './home/sections/Navbar.vue'
import Package from '@/components/Package.vue'

export default {
  name: 'Base',
  title: 'Pacote Base',
  data() {
    return { id: 'base', name: 'Base', price: 160 }
  },
  components: {
    Navbar,
    Package
  }
}
</script>
